// To be used every time multiple classes are needed. Can handle boolean expressions
export const combine = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// To be used to handle extra styles from contentful that might be null
export const getExtraStyles = (styles) => styles || {};
